import { Component, Inject } from '@angular/core';
import { OnInit } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmponboardingService } from '../services/emponboarding.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

function amplussolarEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    if (email && !(email.endsWith('@amplussolar.com') || email.endsWith('@petronas.com'))) {
      // If the email does not end with @amplussolar.com
      return { amplussolarEmail: true };
    }
    return null; // If the email is valid or the control is empty
  };
}

@Component({
  selector: 'app-add-to-emp',
  templateUrl: './add-to-emp.component.html',
  styleUrls: ['./add-to-emp.component.css']
})
export class EmpAddComponent implements OnInit {
  fb = new FormBuilder();
  departments: any;
  companies: any;
  managers: any;
  statuses: any;
  employmentTypes: any;
  hiringTypes: any;
  physicalLocations: any;
  businesses: any;
  umail: any;
  email: any;
  personalInfoForm: FormGroup;
  professionalInfoForm: FormGroup;
  initials = ['Mr', 'Ms', 'Mrs'];
  dialogRef: any;
  gotData: boolean = false;
  minDate: any;
  maxDate: any;
  on_roll_emp_id: any;
  off_roll_emp_id: any;
  jobTitles: any;
  transformedManagers: any;
  user_exists: boolean = true;
   companyTypes:any;
  selectedCompanyType: string = '';
  selectedEmploymentType: string = '';
  emp_id_by_company:any;
  companies_in_company:any;
  filteredCompanyList:any;

  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private empOnboardingService: EmponboardingService
  ) {

    this.personalInfoForm = this.fb.group({})
    this.professionalInfoForm = this.fb.group({
      company_types:['', Validators.required],
      employment_type: ['', Validators.required],
      emp_id: ['', [Validators.required]],
      job_title: ['', Validators.required],
      functional_designation: [''],
      uan_number: [''],
      doj: [null, Validators.required],
      physical_location: ['', Validators.required],
      manager: [null, Validators.required],
      department: ['', Validators.required], //get from employee table
      functional_department: [''],
      business: ['', Validators.required],
      company: ['', Validators.required],
      hiring_type: ['', Validators.required],
      status: [0, Validators.required],
      email: ["", [Validators.required, amplussolarEmailValidator()]],
    })


  }


  ngOnInit() {
    this.professionalInfoForm.get('employment_type')?.disable();
    this.professionalInfoForm.get('company')?.disable();
    this.professionalInfoForm.get('company_types')?.valueChanges.subscribe((company) => {
    this.selectedCompanyType = company;
    if (company) {
    this.professionalInfoForm.get('employment_type')?.enable();
    this.professionalInfoForm.get('company')?.enable();
     const filteredCompanies = this.companies_in_company[company] || [];
    this.filteredCompanyList = filteredCompanies;
  } else {
    this.professionalInfoForm.get('employment_type')?.disable();
    this.professionalInfoForm.get('company')?.disable();
    this.professionalInfoForm.get('emp_id')?.setValue(''); 
    this.filteredCompanyList = [];
  }
    this.updateEmpId();
  });

  this.professionalInfoForm.get('employment_type')?.valueChanges.subscribe((employmentType) => {
    this.selectedEmploymentType = employmentType;
    this.updateEmpId();
  });

    this.umail = this.route.snapshot.queryParamMap.get('umail');
    this.email = this.route.snapshot.queryParamMap.get('email');

    this.empOnboardingService.getEmpDefaultParams(this.email).subscribe((response: any) => {
      this.jobTitles = response.jobTitles;
      this.departments = response.depts;
      this.companies = response.companies;
      this.companies_in_company=response.companies_in_company;
      this.managers = response.managers;
      this.transformedManagers = this.managers.map((manager: any[]) => ({
        id: manager[0],
        name: manager[1]
      }));

      this.businesses = response.businesses;
      let year = parseInt(response.date.slice(0, 4));
      let month = (response.date.slice(5, 7))
      let day = (response.date.slice(8, 10))
      this.minDate = `${year - 1}-${month}-${day}`
      this.on_roll_emp_id = response.on_roll_emp_id;
      this.off_roll_emp_id = response.off_roll_emp_id;
      this.maxDate = `${year + 1}-${month}-${day}`
      this.statuses = response.statuses;
      this.employmentTypes = response.employmentTypes;
      this.companyTypes = response.company_types;
      this.emp_id_by_company=response.emp_id_by_company;
      this.hiringTypes = response.hiringTypes;
      this.physicalLocations = response.physicalLocations;
      this.user_exists = response.user_exists;
      this.empOnboardingService.getProfile(this.umail, this.email).subscribe((response: any) => {
        // create controls in persolInfoForm for each key in response
        Object.keys(response).forEach((key) => {
          this.personalInfoForm.addControl(key, this.fb.control(null));
        });

        // this.personalInfoForm.get('emp_id')?.setValue();
        this.personalInfoForm.patchValue(response);
        this.personalInfoForm.disable();
        this.professionalInfoForm.get('emp_id')?.disable();
        this.gotData = true;
        (error: any) => {
          console.log(error);
        }
      })
    })


  }

updateEmpId() {
  const company = this.selectedCompanyType;
  const type = this.selectedEmploymentType;

  if (!company || !type) {
    this.professionalInfoForm.get('emp_id')?.setValue('');
    return;
  }

  const mapping = this.emp_id_by_company[company];

  if (!mapping) {
    this.professionalInfoForm.get('emp_id')?.setValue('');
    return;
  }

  let empId = '';
  switch (type) {
    case 'On-Roll':
      empId = mapping.on_roll_emp_id;
      break;
    case 'Off-Roll':
      empId = mapping.off_roll_emp_id;
      break;
    case 'Intern':
      empId = mapping.intern_emp_id;
      break;
    default:
      empId = '';
  }

  this.professionalInfoForm.get('emp_id')?.setValue(empId);
}



  onSubmit() {
    this.professionalInfoForm.get('emp_id')?.enable();
    // console.log(this.professionalInfoForm.value)
    this.empOnboardingService.addEmp({
      email: this.email,
      umail: this.umail, professionalDetails: this.professionalInfoForm.value
    })
      .subscribe((response: any) => {
        this.ngOnInit();
        console.log(response);
        (error: any) => {
          console.log(error);
        }
      }, error => {
        // Handling email/emp_id errors
        if (error === 'ACTIVE_EMAIL_EXISTS') {
          this.openErrorDialog('Active Employee with given email already exists! Please provide a different email.');
        } else if (error === 'EMP_ID_EXISTS') {
          this.openErrorDialog('Employee ID already exists! Cannot create new employee with existing ID.');
        }
        else this.openErrorDialog('An unexpected error occurred.');
        this.professionalInfoForm.get('emp_id')?.disable();
      });
  }
  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      data: { errorMessage },
    });
  }
}

